import type { PropsWithChildren } from 'react'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { ErrorBoundary } from '@/app/ErrorBoundary'
import { ToastProvider } from '@/components/ui/Toast'
import { persistor, store } from '@/store'

const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID ?? ''

export const AppProviders = ({ children }: PropsWithChildren) => (
  <ErrorBoundary>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
          <ToastProvider>{children}</ToastProvider>
        </GoogleOAuthProvider>
      </PersistGate>
    </Provider>
  </ErrorBoundary>
)
